import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./../managerPage/css/card.css";
import "./../managerPage/css/table.css";
import "./../managerPage/css/form.css";
import "./../managerPage/css/dropdown.css";
import { IoIosSearch } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoIosCloseCircle } from "react-icons/io";
import { IoMdCloseCircle } from "react-icons/io";
import { TiArrowSortedUp } from "react-icons/ti";
import {
  ChevronLeft,
  Calendar as CalendarIcon,
  Clock,
  User,
  X,
} from "lucide-react";
import {
  useGetMaintenanceRequestQuery,
  useGetSchedulesByUserIDQuery,
  useUpdatePreventiveMaintenanceMutation,
  useGetPreventiveSchedulesByUserIDQuery,
  useGetMaintenanceByAssetCodeQuery,
} from "../../slices/maintenanceApiSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { maintenanceApiSlice } from "../../slices/maintenanceApiSlice";
import { useGetAssetByAssetCodeQuery } from "../../slices/assetApiSlice";
import Tippy from "@tippyjs/react";
import {
  useGetUserByEmailQuery,
  useGetUsersQuery,
  useGetDepartmentQuery,
} from "../../slices/userApiSlice";
import Select from "react-select";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import {
  Select as ShadSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Badge } from "../../components/ui/badge";

const SupervisorWO = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [selectedWorkStatus, setSelectedWorkStatus] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get("status");
    if (status) {
      setSelectedWorkStatus(status);
    } else {
      setSelectedWorkStatus("");
    }
  }, [searchParams]);

  const [rescheduleModalData, setRescheduleModalData] = useState(null);
  const [statusPending, setStatusPending] = useState(null);

  const [assignTime, setAssignTime] = useState("");
  const [assignDate, setAssignDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedTechnicianId, setSelectedTechnicianId] = useState(null);
  const [selectedTechnicianUpdate, setSelectedTechnicianUpdate] =
    useState(null);
  const rowsPerPage = 10;

  const selectUserInfo = (state) => state.auth.userInfo || {};
  const getUserEmail = createSelector(
    selectUserInfo,
    (userInfo) => userInfo?.username || "",
  );

  const email = useSelector(getUserEmail);
  const { data: userByEmial } = useGetUserByEmailQuery(email, {
    skip: !email, // Skip query if email is empty
  });

  const userID = userByEmial?.user?.userId;

  const academyId = userByEmial?.user?.academyId;

  const departmentId = userByEmial?.user?.departmentId;

  const { data: users, isLoading } = useGetUsersQuery();

  const filteredUsers = users?.filter(
    (user) =>
      user.academyId === academyId &&
      user.departmentId === departmentId &&
      typeof user.role?.name === "string" &&
      user.role.name.toLowerCase() === "technician",
  );

  const workerOptions = filteredUsers?.map((user) => ({
    label: user.email,
    value: user.email,
  }));

  const updatedOption = workerOptions?.find(
    (w) => w.label === selectedTechnicianUpdate,
  );

  const {
    data: userSchedules,
    // isLoading: userSchedulesLoading,
    error: userSchedulesError,
    refetch,
  } = useGetPreventiveSchedulesByUserIDQuery(userID, {
    skip: !userID,
  });
  const assetCode = userSchedules?.assetCode;

  const { data: scheduleData } = useGetAssetByAssetCodeQuery(assetCode, {
    skip: !assetCode,
  });

  const [data, setData] = useState([]);
  const [repairs, setRepairs] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      toast.loading("Please wait: Loading work order details.", {
        id: "loading-work-orders",
      });
    } else {
      toast.dismiss("loading-work-orders");
    }
  }, [isLoading]);

  useEffect(() => {
    const fetchRepairDetails = async () => {
      if (userSchedules && userSchedules.length) {
        const repairPromises = userSchedules.map(async (schedule) => {
          try {
            const asset = await dispatch(
              maintenanceApiSlice.endpoints.getAssetByAssetCode.initiate(
                schedule?.assetCode,
              ),
            ).unwrap();

            return {
              ...schedule,
              asset,
            };
          } catch (err) {
            console.error(
              `Error fetching asset for ${schedule?.assetCode}:`,
              err,
            );
            return null;
          }
        });

        const repairResults = await Promise.all(repairPromises);
        const validData = repairResults.filter(Boolean);
        console.log("v", validData);

        // 🔽 Sort newest first using repairID
        const sortedData = validData.sort((a, b) =>
          b.maintenanceID.localeCompare(a.maintenanceID),
        );

        // console.log('Sorted Results:', sortedResults.map(r => ({ scheduleDate: r.scheduleDate, createdAt: r.createdAt })));
        setData(sortedData);
      }
    };

    fetchRepairDetails();
  }, [userSchedules, dispatch]);

  console.log("data", data);
  console.log("userSchedules outside useEffect:", userSchedules);

  const today = new Date().toISOString().split("T")[0];

  const [updateSchedule, { isLoading: userSchedulesLoading }] =
    useUpdatePreventiveMaintenanceMutation();

  const handleSchedule = async () => {
    const maintenanceID = modalData.maintenanceID; // Ensure the correct way to access repairID

    if (!maintenanceID) {
      toast.error(
        "Repair ID Not Found: The specified Repair ID could not be located. Please check and try again.",
      );

      return;
    }
    const matchingSchedule = userSchedules.find(
      (schedule) => schedule.maintenanceID === maintenanceID,
    );

    if (!matchingSchedule) {
      toast.error(
        "Schedule Not Found: No schedule found for the provided Maintenance ID. Please verify and try again.",
      );

      return;
    }

    const id = matchingSchedule.maintenanceID;
    console.log("scheduleId", id);

    if (!selectedTechnicianId) {
      toast.error("Technician email is missing.");
      return;
    }

    // Prepare the updated data for the schedule
    const maintenance = {
      technicianEmail: selectedTechnicianId,
      maintenanceID: matchingSchedule.maintenanceID,
    };

    try {
      await updateSchedule({ id, maintenance }).unwrap();
      toast.success("Schedule updated successfully!");
      // refetchRepairRequest();
      handleCloseModal();
    } catch (error) {
      toast.error(error?.data?.message || "Update failed");
      console.error("Update schedule error:", error);
    }
    refetch();
  };

  const handleReschedule = async () => {
    const maintenanceID = rescheduleModalData.maintenanceID; // Ensure the correct way to access repairID

    if (!maintenanceID) {
      toast.error("Repair ID not found.");
      return;
    }
    const matchingSchedule = userSchedules.find(
      (schedule) => schedule.maintenanceID === maintenanceID,
    );

    if (!matchingSchedule) {
      toast.error("Reschedule Not Found", {
        description:
          "No reschedule found for the provided Maintenance ID. Please verify and try again.",
      });

      return;
    }

    const id = matchingSchedule.maintenanceID;
    console.log("scheduleId", id);

    if (!selectedTechnicianUpdate) {
      toast.error("Missing Technician Email", {
        description:
          "Technician email is missing. Please provide it and try again.",
      });

      return;
    }

    // Prepare the updated data for the schedule
    const maintenance = {
      technicianEmail: selectedTechnicianUpdate,
      maintenanceID: matchingSchedule.maintenanceID,
    };

    try {
      await updateSchedule({ id, maintenance }).unwrap();
      toast.success("Schedule updated successfully!");
      // refetchRepairRequest();
      handleCloseModal2();
    } catch (error) {
      toast.error(error?.data?.message || "Update failed");
      console.error("Update schedule error:", error);
    }
    refetch();
  };

  // Function to get the class based on workstatus
  const getWorkOrderStatusClass = (status) => {
    switch (status) {
      case "pending":
        return "pending-status";
      case "inprogress":
        return "in-progress-status";
      case "completed":
        return "completed-status";
      default:
        return "";
    }
  };

  // Extract unique work statuses from data
  const uniqueWorkStatuses = [
    { value: "", label: "All Work status" },
    ...Array.from(new Set(data.map((item) => item.status?.toLowerCase()))).map(
      (status) => ({
        value: status,
        label: status ? status.charAt(0).toUpperCase() + status.slice(1) : "",
      }),
    ),
  ];

  // Filtering data based on search and priority selection and work status
  const searchRecursively = (obj, searchTerm) => {
    if (typeof obj !== "object" || obj === null) {
      return (
        obj &&
        obj
          .toString()
          .toLowerCase()
          .includes(searchTerm?.toLowerCase() || "")
      );
    }

    // Check all values in the object (including nested objects)
    return Object.values(obj).some((value) =>
      searchRecursively(value, searchTerm),
    );
  };

  // const searchRecursively = (obj, searchTerm) => {
  //   if (!obj || typeof obj !== "object") return false;

  //   for (const key in obj) {
  //     if (Object.hasOwn(obj, key)) {
  //       const value = obj[key];
  //       if (typeof value === "string" && value.toLowerCase().includes(searchTerm.toLowerCase())) {
  //         return true;
  //       } else if (typeof value === "object") {
  //         if (searchRecursively(value, searchTerm)) return true;
  //       }
  //     }
  //   }
  //   return false;
  // };
  const filteredData = data.filter((item) => {
    const matchesSearch = searchRecursively(item, searchTerm);
    const matchesStatus =
      !selectedWorkStatus ||
      item.status?.toLowerCase() === selectedWorkStatus.toLowerCase();
    return matchesSearch && matchesStatus;
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const displayedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );
  console.log("displayedData", displayedData);

  const handleSelectRow = (assetCode) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(assetCode)
        ? prevSelectedRows.filter((item) => item !== assetCode)
        : [...prevSelectedRows, assetCode],
    );
  };

  const handleScheduleView = (item) => {
    setModalData(item);
    setStartDate(item?.startDate);
    setEndDate(item?.endDate);
    setAssignTime(item?.timeStart);
  };
  const handleCloseModal = () => {
    setModalData(null);
    setSelectedTechnicianId(null);
    setStartDate(null);
    setEndDate(null);
    setAssignTime(null);
  };
  const handleCloseModal2 = () => {
    setRescheduleModalData(null);
    setSelectedTechnicianUpdate(null);
    setStartDate(null);
    setEndDate(null);
    setAssignTime(null);
    setStatusPending(null);
  };
  const handleRescheduleView = (item) => {
    setRescheduleModalData(item);
    setSelectedTechnicianUpdate(item?.technicianEmail || "");
    setStartDate(item?.startDate);
    setEndDate(item?.endDate);
    setAssignTime(item?.timeStart);
    setStatusPending(item?.status);
  };

  const [sortOrder, setSortOrder] = useState({ column: null, ascending: true });
  // const sortData = (column, ascending) => {
  //   const sortedData = [...data].sort((a, b) => {
  //     if (a[column] < b[column]) return ascending ? -1 : 1;
  //     if (a[column] > b[column]) return ascending ? 1 : -1;
  //     return 0;
  //   });
  //   setData(sortedData);
  // };

  const handleSort = (field) => {
    const ascending = sortOrder.column === field ? !sortOrder.ascending : true;

    const sorted = [...data].sort((a, b) => {
      const aValue = getNestedValue(a, field);
      const bValue = getNestedValue(b, field);

      if (aValue < bValue) return ascending ? -1 : 1;
      if (aValue > bValue) return ascending ? 1 : -1;
      return 0;
    });

    setData(sorted);
    setSortOrder({ column: field, ascending });
  };
  const getNestedValue = (obj, path) => {
    return path?.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "";
  };

  return (
    <div className="p-4 sm:py-6 sm:px-8 space-y-4">
      {/* Header */}
      <div className="space-y-2 mb-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          <div className="flex items-center gap-3">
            <h1 className="text-xl sm:text-2xl font-bold text-zinc-800">
              Work Order
            </h1>
          </div>
        </div>
        <p className="text-zinc-600">
          Manage and assign work orders to technicians
        </p>
      </div>

      <div className="">
        <div className="">
          <div className="flex flex-col lg:flex-row gap-4 mb-6 lg:items-center lg:justify-between">
            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              {/* Search Input */}
              <div className="w-full lg:flex-1 lg:min-w-60">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search work orders..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg pl-10 text-sm sm:text-base"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Work Status Filter */}
              <div className="w-full lg:w-48">
                <Select
                  classNamePrefix="custom-select-workstatus"
                  className="workstatus-dropdown"
                  options={uniqueWorkStatuses}
                  value={uniqueWorkStatuses.find(
                    (option) => option.value === selectedWorkStatus,
                  )}
                  onChange={(selectedOption) => {
                    setSelectedWorkStatus(
                      selectedOption ? selectedOption.value : "",
                    );
                  }}
                  isClearable
                  isSearchable={false}
                  placeholder="Filter by status"
                />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto min-w-0">
              <table className="w-full min-w-max">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset Code
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Report Time
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Asset ID
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Area
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Workstatus
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Description
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {displayedData.map((item, index) => (
                    <tr
                      key={item.maintenanceID || index}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.assetCode}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.asset?.title}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.timeStart}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.startDate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.asset?.assetID}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.asset?.assetArea}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            item.status === "Completed"
                              ? "bg-green-100 text-green-800"
                              : item.status === "In Progress"
                                ? "bg-blue-100 text-blue-800"
                                : item.status === "Pending"
                                  ? "bg-orange-100 text-orange-800"
                                  : "bg-gray-100 text-gray-800"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.description}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        {(() => {
                          const s = item.status?.toLowerCase() || "";
                          const hasAssignee =
                            item.technicianEmail &&
                            item.technicianEmail.trim() !== "";
                          if (
                            s === "in progress" ||
                            s === "inprogress" ||
                            s === "completed"
                          ) {
                            return (
                              <button
                                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                onClick={() => handleRescheduleView(item)}
                              >
                                View
                              </button>
                            );
                          } else if (hasAssignee && s === "pending") {
                            return (
                              <button
                                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                                onClick={() => handleRescheduleView(item)}
                              >
                                Reschedule
                              </button>
                            );
                          } else {
                            return (
                              <button
                                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                onClick={() => handleScheduleView(item)}
                              >
                                Schedule
                              </button>
                            );
                          }
                        })()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="pagination">
            <span>{filteredData.length} Results</span>
            <div>
              {[...Array(totalPages).keys()].slice(0, 5).map((num) => (
                <button
                  key={num}
                  className={currentPage === num + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(num + 1)}
                >
                  {num + 1}
                </button>
              ))}
              <span>...</span>
              <button onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
              </button>
            </div>
          </div>
        </div>

        {/* Modal for schedule Request */}
        {modalData && (
          <div className="modal-overlay">
            <div className="modal-content">
              {/* Close Button */}
              <div className="modal-header">
                <h2 style={{ fontSize: "18px" }} className="form-h">
                  Schedule Form
                </h2>
                <button className="close-btn" onClick={handleCloseModal}>
                  <IoIosCloseCircle
                    style={{ color: "#897463", width: "20px", height: "20px" }}
                  />
                </button>
              </div>

              {/* Assign Dropdown */}
              <div className="schedule-form">
                <div className="modal-content-field">
                  <label>Assign Technician:</label>
                  <div style={{ width: "100%", maxWidth: "350px" }}>
                    <Select
                      classNamePrefix="custom-select-department"
                      className="workstatus-dropdown"
                      options={workerOptions}
                      value={
                        workerOptions?.find(
                          (w) => w.value === selectedTechnicianId,
                        ) || ""
                      }
                      onChange={(selectedOption) => {
                        setSelectedTechnicianId(selectedOption?.label || "");
                        console.log("Selected Worker:", selectedOption);
                      }}
                      isClearable
                    />
                  </div>
                </div>

                {/* Assign Date */}
                <div className="modal-content-field">
                  <label>Start Date:</label>
                  <input type="text" value={startDate} readOnly />
                </div>
                {/* Assign Date */}
                <div className="modal-content-field">
                  <label>End Date:</label>
                  <input type="text" value={endDate} readOnly />
                </div>

                <div className="modal-content-field">
                  {/* Assign Time */}
                  <label>Assign Time:</label>
                  <input type="text" value={assignTime} readOnly />
                </div>

                <div className="modal-buttons">
                  <button
                    className="accept-btn"
                    style={{ width: "80px" }}
                    onClick={handleSchedule}
                    disabled={userSchedulesLoading}
                  >
                    {userSchedulesLoading ? "Saving..." : "Done"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Schedule Details Modal - Shadcn Design */}
        <Dialog
          open={!!rescheduleModalData}
          onOpenChange={(open) => !open && handleCloseModal2()}
        >
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle className="text-2xl font-bold flex items-center gap-2">
                {statusPending === "Pending" ? (
                  <>
                    <CalendarIcon className="h-6 w-6 text-blue-600" />
                    Reschedule Maintenance
                  </>
                ) : (
                  <>
                    <CalendarIcon className="h-6 w-6 text-slate-600" />
                    Schedule Details
                  </>
                )}
              </DialogTitle>
            </DialogHeader>

            <div className="space-y-6 py-4">
              {/* Assign Technician */}
              <div className="space-y-2">
                <Label className="text-sm font-semibold flex items-center gap-2">
                  <User className="h-4 w-4 text-slate-600" />
                  Assign Technician
                </Label>
                <ShadSelect
                  value={selectedTechnicianUpdate || ""}
                  onValueChange={(value) => {
                    setSelectedTechnicianUpdate(value);
                    console.log("Selected Worker:", value);
                  }}
                  disabled={statusPending !== "Pending"}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select a technician" />
                  </SelectTrigger>
                  <SelectContent>
                    {workerOptions?.map((worker) => (
                      <SelectItem key={worker.value} value={worker.value}>
                        {worker.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </ShadSelect>
              </div>

              {/* Date and Time Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Start Date */}
                <div className="space-y-2">
                  <Label className="text-sm font-semibold flex items-center gap-2">
                    <CalendarIcon className="h-4 w-4 text-slate-600" />
                    Start Date
                  </Label>
                  <Input
                    type="text"
                    value={startDate}
                    readOnly
                    className="bg-slate-50"
                  />
                </div>

                {/* End Date */}
                <div className="space-y-2">
                  <Label className="text-sm font-semibold flex items-center gap-2">
                    <CalendarIcon className="h-4 w-4 text-slate-600" />
                    End Date
                  </Label>
                  <Input
                    type="text"
                    value={endDate}
                    readOnly
                    className="bg-slate-50"
                  />
                </div>
              </div>

              {/* Assign Time */}
              <div className="space-y-2">
                <Label className="text-sm font-semibold flex items-center gap-2">
                  <Clock className="h-4 w-4 text-slate-600" />
                  Assigned Time
                </Label>
                <Input
                  type="text"
                  value={assignTime}
                  readOnly
                  className="bg-slate-50"
                />
              </div>

              {/* Status Badge */}
              {statusPending && (
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-slate-700">
                    Status:
                  </span>
                  <Badge
                    variant={
                      statusPending === "Pending" ? "outline" : "secondary"
                    }
                    className={
                      statusPending === "Pending"
                        ? "bg-amber-100 text-amber-700 border-amber-300"
                        : ""
                    }
                  >
                    {statusPending}
                  </Badge>
                </div>
              )}
            </div>

            {statusPending === "Pending" && (
              <DialogFooter>
                <Button variant="outline" onClick={handleCloseModal2}>
                  Cancel
                </Button>
                <Button
                  onClick={handleReschedule}
                  disabled={userSchedulesLoading}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  {userSchedulesLoading ? "Saving..." : "Save Changes"}
                </Button>
              </DialogFooter>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default SupervisorWO;
